import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Testimonials from '../home/testimonials.js';
import { ReactComponent as IconDropdown } from '../../media/icons/dropdown.svg';


export default class BenefitsPlanners extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            background_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero.webp",
            question_expanded: false,
            questions_content: [
                /* {
                    "question": "Why should I create and sell my itineraries on Guidr?",
                    "answer": "If you have deep knowledge of a destination, Guidr allows you to turn that expertise into passive income. Instead of answering the same travel questions repeatedly, you can package your insights into itineraries that help travelers while earning from your work."
                },
                {
                    "question": "How is Guidr different from starting my own travel blog or working with a travel agency?",
                    "answer": "Unlike running a blog, which requires significant time and effort to monetize, Guidr lets you instantly list and sell itineraries without worrying about website management, SEO, or marketing. Compared to traditional travel agencies, you retain full control over your content and earnings, without being limited by commission-based sales."
                }, */
                {
                    "question": "Who can and should become a travel expert on Guidr?",
                    "answer": "Anyone with strong knowledge of a destination - locals, travel bloggers, tour guides, experienced travelers, hoteliers, or tourism professionals - can create and share itineraries. You don’t need to be a professional travel agent to get started."
                },
                {
                    "question": "Why should I create and offer my itineraries on Guidr?",
                    "answer": "If you have deep knowledge of a destination, Guidr allows you to turn that expertise into passive income. Instead of answering the same travel questions repeatedly, you can package your insights into itineraries that help travelers while earning from your work."
                },
                {
                    "question": "Why should hoteliers and tourism professionals create and offer itineraries on Guidr?",
                    "answer": "Hoteliers and tourism professionals are perfectly positioned to create high-value itineraries because they already understand what travelers want. Offering itineraries on Guidr can drive more direct bookings and increase your visibility in the travel community."
                },
                {
                    "question": "Do I need to create full-length itineraries, or can I share niche experiences?",
                    "answer": "You can create full multi-day itineraries or focus on niche experiences, such as food tours, weekend getaways, or hidden gems. Travelers look for a wide range of itineraries, so unique and well-structured plans often perform well."
                },
                {
                    "question": "What will users see about my itinerary?",
                    "answer": "Users that are not logged in or have not yet unlocked your itinerary will only see basic information as well as all pictures. Only once a user unlocked your itinerary will they be able to see the full itinerary, including all details, locations, and recommendations."
                },
                /* {
                    "question": "How much can I earn on Guidr?",
                    "answer": "Your earnings depend on how many itineraries you sell and their pricing. Top travel experts can generate substantial passive income, especially by creating high-quality, evergreen itineraries."
                }, */
                /* {
                    "question": "Can I monetize my itineraries?",
                    "answer": "Yes! You can choose to offer free itineraries or set a price for each itinerary you create. Earnings will be deposited into your account based on purchases."
                }, */
                /* {
                    "question": "Why should I use Guidr instead of selling my itineraries on my own?",
                    "answer": "Guidr provides an existing audience of travelers actively looking for itineraries, saving you from the hassle of building and marketing your own site. Plus, we handle payments, customer support, and platform security so you can focus on content creation."
                }, */
                {
                    "question": "Why should I use Guidr instead of offering my itineraries on my own?",
                    "answer": "Guidr provides an existing audience of travelers actively looking for itineraries, saving you from the hassle of building and marketing your own site. Plus, we handle all the logistics, like customer support and platform security so you can focus on content creation."
                },
                /* {
                    "question": "Can I still sell my itineraries elsewhere if I list them on Guidr?",
                    "answer": "Yes, you retain ownership of your itineraries and can sell them on multiple platforms. However, exclusive content on Guidr may be promoted more within our community."
                }, */
                {
                    "question": "Can I still post my itineraries elsewhere if I list them on Guidr?",
                    "answer": "Yes, you retain ownership of your itineraries and can post them on multiple platforms. However, exclusive content on Guidr may be promoted more within our community."
                },
                {
                    "question": "What types of itineraries perform best?",
                    "answer": "Detailed, well-structured itineraries with insider tips, high-quality images, and recommendations based on personal experience tend to attract many travelers."
                },
                {
                    "question": "Do I need to have professional travel experience to create an itinerary?",
                    "answer": "Not necessarily. If you have extensive knowledge of a destination and can provide valuable insights, you can share itineraries even if you’re not a professional travel agent."
                },
                {
                    "question": "Can I edit or update my itineraries after publishing?",
                    "answer": "Yes, you can edit and update your itineraries anytime to keep them relevant and improve their quality."
                },
                /* {
                    "question": "How do I get paid for my itinerary sales?",
                    "answer": "Payments are processed through our secure payment system. You can link your bank account or PayPal to receive payouts on a scheduled basis."
                }, */
                {
                    "question": "How do I promote my itineraries?",
                    "answer": "You can share your itinerary links on social media, your blog, or other platforms."
                },
                {
                    "question": "Are there any restrictions on the types of itineraries I can upload?",
                    "answer": "Itineraries should comply with our content guidelines and should not promote unsafe or illegal activities."
                },
                /* {
                    "question": "What happens if someone requests a refund for my itinerary?",
                    "answer": "Refunds are handled based on our policy. If a refund is issued, we will notify you and may ask for clarification on any issues raised by the buyer."
                }, */
                {
                    "question": "How do I get started?",
                    "answer": "You can sign up as a travel expert, complete your profile, and use our itinerary builder to create and publish your itineraries. You can then market your itineraries on other platforms and make them available to travelers on Guidr."
                }
            ]
        };

        this.toggleQuestion = this.toggleQuestion.bind(this);
    }


    toggleQuestion(question) {
        if (question === this.state.question_expanded) {
            this.setState({
                question_expanded: false
            });
        } else {
            this.setState({
                question_expanded: question
            });
        }
    }


    render() {

        return (
            <div className="content-container">

                <Helmet>
                    {/* Add the breadcrumb schema as JSON-LD */}
                    <script type="application/ld+json">
                        {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Guidr Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Guidr for travel creators",
                                    "item": "https://guidr.net/creators"
                                }
                                ]
                            }
                        `}
                    </script>
                    <title>{"Monitize your trip itineraries and travel content | Guidr"}</title>
                </Helmet>

                <div className="content-container hero-container">
                    <div className="hero__background">
                        <img src={this.state.background_url} alt={""} className={"hero__background-inner"} />
                    </div>
                    <div className="hero__background hero__background--overlay"></div>

                    <div className="content-wrapper--wide persona__hero-wrapper">
                        <div></div>
                        <div className="persona__hero__title-container">
                            <div className="persona__hero__title__element">
                                <h1 className="hero__title__static-content text-herotitle text-color-light">
                                    Grow your community of travel planners
                                </h1>
                            </div>

                            <div className="persona__hero__title__element">
                                <h2 className="hero__title__static-content text-subtitle text-color-light">
                                    Share your itineraries and help travelers plan their dream trip based on your experience
                                </h2>
                            </div>

                            <Link
                                to={"/signup"}
                                className="persona__hero__title__button button button-large button-primary-light"
                            >
                                Sign up to create itineraries
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="content-wrapper">
                    <div className="persona__explainer-container">

                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">1</div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Create and share
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_1.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">✍️ Build detailed itineraries</span> with activities, locations, and recommendations.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">💡 Add tips, hidden gems</span>, and personal insights.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    {/* <span className="text-bold">💰 Set a price</span> or offer itineraries for free to your community. */}
                                    <span className="text-bold">💬 Offer itineraries</span> to your community.
                                </p>
                            </div>
                        </div>

                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">2</div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Market your itineraries
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_2.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">📢 Market your itineraries</span> to your community through social media.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🔗 Redirect your community</span> to your Guidr trip page.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🚀 Gain additional exposure</span> to travelers looking for itineraries on Guidr.
                                </p>
                            </div>
                        </div>

                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">3</div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Earn and engage
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_3.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                {/* <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">💵 Get paid</span> when travelers purchase your itinerary.
                                </p> */}
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🤝 Interact with travelers</span> through Q&A or personalized tips.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">📈 Continue to grow your community</span> across platforms while managing your itineraries with Guidr.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="content-wrapper">
                    <Testimonials
                        data={this.props.testimonials}
                    />
                </div>

                <div className="content-wrapper">
                    <div className="persona__faq-container">
                        <h2 className="persona__faq__title text-title">
                            Frequently asked questions (FAQ)
                        </h2>

                        <div className="persona__faq-wrapper">

                            {this.state.questions_content.map((element, i) => (
                                <div key={i} className={"persona__faq__element" + (this.state.question_expanded === i ? " persona__faq__element--expanded" : "")}>
                                    <div onClick={() => this.toggleQuestion(i)} className="persona__faq__element__question-wrapper">
                                        <div className="persona__faq__element__question__question">
                                            {element.question}
                                        </div>
                                        <div className={"persona__faq__element__question__icon"}>
                                            <IconDropdown className="persona__faq__element__question__icon-inner" />
                                        </div>
                                    </div>
                                    <div className={"persona__faq__element__answer"}>
                                        {element.answer}
                                    </div>
                                </div>
                            ))}

                        </div>

                    </div>
                </div>

            </div>
        )
    }
}
